module.exports = __webpack_public_path__ + "img/Den_Norske_Dictionarium_Utdrag.23e8095c.jpg";